import React from 'react'
import { useTranslation } from "react-i18next";
import leftarrow from "../../../../assets/images/left-arrow.svg";
import { useHistory } from "react-router-dom";
import * as moment from 'moment'
import { Footer } from '../../../common/footer/footer';
import styles from './plansSummary.module.css';
const PLansSummaryJsx = (props) => {
  const { t } = useTranslation();
  const history = useHistory();
  const {
    promoCode,
    onPromoCodeChnage,
    onApplyButtonClick,
    onRemovePromoCode,
    discount,
    onInvoiceButtonClick,
    onViaCard,
    isPromoApplied
  } = props;

  const { period, planType,rate } = JSON.parse(localStorage.getItem('planData'));
 
  const flowType = localStorage.getItem("AdminFlow");
  let flowName = localStorage.getItem('AdminFlow');

  const date = new Date();

  
  const getDiscount = () => rate * discount/100
  const  final_rate = rate - getDiscount()
  // const getTaxRate = () => final_rate * .13
  // const subTotal = () => parseFloat(final_rate) + parseFloat(final_rate * .13)
  const subTotal = () => parseFloat(final_rate)


  return (
    <>
      <section className={`expertregistrationnew ${flowType}-registration`}>
        <div className="container">
        <div className={`${styles.mainloginscreeninner}`}>
            <div className={`${styles.leftsightbackdetails}`}>
              <div className="detailsleft plaindetailsleft  d-flex align-items-center justify-content-center">
              <div className="back_btn" onClick={() => history.goBack()}><img src={leftarrow} alt={' '} /></div>
                <h1>{t("PLANSUMMARY.TITLE")}</h1>
              </div>
              <div className={`numberingwizerd ${flowType}-numberingwizerd`}>
                  <ul className="d-flex align-items-center justify-content-center ">
                    <li>1</li>
                    <li>2</li>
                    <li>3</li>
                    <li className="active">4</li>
                  </ul>
                </div>
            </div>
          </div>
          <div className={`${styles.formsection}`}>
              <div className="institutelogintext passwordauthorization">
              <h5 className="text-center">{t("PLANSUMMARY.PAYINGFOR")}</h5>
                  <h5 className="text-center">{t("PLANSUMMARY.SELECTIONS")}</h5>
               
                {(flowName === 'expert'||flowName === 'institute') &&<div className="promosection mb-4">
                <label>Enter Promo Code</label>
                 <div className="d-flex">
                  <input 
                    type="text" 
                    className="promo-input form-control" 
                    placeholder=" " 
                    value={promoCode} 
                    onChange={onPromoCodeChnage}
                    disabled={isPromoApplied}
                  />
                  {!isPromoApplied ? (
                    <input 
                      type="button" 
                      className="mainbutton form-control" 
                      value="Apply" 
                      onClick={onApplyButtonClick} 
                    />
                  ) : (
                    <input 
                      type="button" 
                      className="mainbutton  form-control" 
                      value="Remove" 
                      onClick={onRemovePromoCode}
                      
                    />
                  )}
                </div></div>}

                {isPromoApplied && (
                  <div className="promo-applied-message mt-2">
                    <small className="text-success">
                      ✓ Promo code "{promoCode}" applied successfully! You're saving {discount}%
                    </small>
                  </div>
                )}

                <div className="plansummerytop">
                  <ul>
                      <li>{t("PLANSUMMARY.PLANTYPE")}<span>{planType}</span></li>
                      <li>{t("PLANSUMMARY.PLANDURATION")}<span>{period.split(' ')[0]}</span></li>
                      <li>{t("PLANSUMMARY.STARTDATE")}<span> {moment(date).format('DD MMM YYYY')}</span></li>
                      <li>{t("PLANSUMMARY.ENDDATE")} <span>{moment(date.setMonth(date.getMonth() + (period === 'Annual Billing' ? 12 : 3))).format('DD MMM YYYY')}</span></li>
                  </ul>
                </div>
                <div className="plansummerypop mt-4">
                  {/* <ul>
                    <li>{t("PLANSUMMARY.PLANPRICING")}<span>${getRateBeforeTax()}</span></li>
                    <li>{t("PLANSUMMARY.TAXES")}<span>${rate-getRateBeforeTax()}</span></li>
                    {discount ?<li>{t("PLANSUMMARY.DISCOUNT")} <span></span>{`${discount}%`}</li> : ""}
                    <li>{t("PLANSUMMARY.TOTAL")}<span>{`$${rate-(rate*discount/100)}`}</span></li>
                  </ul> */}
                  {/* new logic */}
                  <ul>
                    <li>{t("PLANSUMMARY.PLANPRICING")}<span>${rate}</span></li>
                    {/* <li>{t("PLANSUMMARY.TAXES")}<span>${getTaxRate()}</span></li> */}
                    {discount ?<li className="text-danger">{t("PLANSUMMARY.DISCOUNT")} <span></span>- ${getDiscount()} ({`${discount}%`})</li> : ""}
                    <li>{t("PLANSUMMARY.TOTAL")}<span>{`$${subTotal()}`}</span></li>
                  </ul>
                </div>
<div className="d-flex justify-content-center align-items-center">
                {(flowName === 'expert'||flowName === 'institute') && <><button type="submit" className="mt-3 mb-3 mainbutton" onClick={()=> onInvoiceButtonClick()}>{"Via Invoice"}</button>
                <div className="mt-3 pl-2 pr-2 mb-3">Or</div></>}
                {/* <button type="submit" className="mt-2 ctaonebutton" onClick={()=> onContinueButtonClick()}>{"Via Card"}</button> */}
                <button type="submit" className="mt-3 mainbutton mb-3" onClick={()=> onViaCard()}>{"Via Online"}</button>
</div>
              </div>

            </div>
      
        </div>
        <Footer/>
      </section>
    </>

  );
};

export default PLansSummaryJsx;